import { UpliftTripType } from "../typings/uplift";
import { TripType } from "./home.constants";

type TripTypeMap = {
  [type in TripType]: UpliftTripType;
};

export const TRIP_TYPE_TO_UPLIFT_TRIP_TYPE: TripTypeMap = {
  [TripType.oneWay]: 'oneway',
  [TripType.roundTrip]: 'roundtrip',
  [TripType.multiCity]: 'open_jaw',
};

export enum CoverGeniusInsurancePolicyTypeEnum {
  COMPREHENSIVE_TRAVEL_INSURANCE = 'comprehensive_travel_insurance',
  OPTOUT = 'optout',
  TRAVEL_FLIGHT_CANCELLATION_COVER = 'travel_flight_cancellation_cover'
}

export const oldPaymentFlowDelayInDays = 62;
export const paymentModalId = 'paymentModalId';
